export enum RecipeComponentType {
  Input = 'Input',
  Output = 'Output'
}
